import React from 'react';
import { EyeVisual } from './components/EyeVisual';
export function App() {
  return <div className="min-h-full w-full bg-[#e6eef4] text-[#1a1a1a]" style={{
    fontFamily: '"Segoe UI", system-ui, Arial, sans-serif'
  }} data-id="element-0">
      {/* WHITE advertisement bar, separated at the very top */}
      <div className="w-full bg-white pt-1 pb-8 text-center text-xs text-gray-500" data-id="element-1">
        Advertisement
      </div>

      {/* WHITE content card floating on the intermediate (#e6eef4) canvas.
                        The intermediate tone shows as the top gap under the advertisement
                        bar and as the side margins around this card. */}
      <main className="mx-auto mt-8 max-w-[1150px] bg-white px-6 pb-9 pt-12 sm:px-16" data-id="element-2">
        <h1 className="text-center text-[28px] font-bold leading-[1.2] text-[#1a1a1a] sm:text-[40px]" data-id="element-3">
          If Your Eye Discharge Is This EXACT Color, You Have{' '}
          <span className="font-black" data-id="element-4">90% Chance</span> of THIS (Do This Now!)
        </h1>

        <div className="my-6" data-id="element-5">
          <div className="mx-auto w-full max-w-[630px]" data-id="element-6">
            <EyeVisual data-id="element-7" />
          </div>
        </div>

        <div className="mx-auto max-w-[1000px] space-y-4 text-[18px] leading-relaxed text-[#333]" data-id="element-8">
          <p data-id="element-9">
            Air Force vision doctors discovered that people with vision problems
            have{' '}
            <a href="https://trackrq.dailyhomewellness.com/click" className="font-bold text-[#2b6dff] hover:underline" data-id="element-10">
              this ONE thing in common...
            </a>
          </p>
          <p data-id="element-11">
            The tests done on 2,398 men and women over 50 revealed that the
            color of the eye discharge hides a{' '}
            <span className="font-bold text-[#1a1a1a]" data-id="element-12">
              very disturbing vision loss symptom.
            </span>
          </p>
          <p data-id="element-13">Ignoring this warning sign could lead to sudden blindness.</p>
          <p data-id="element-14">
            Watch this video explaining if you're at risk and what you should do
            starting tonight to quickly fix your vision.
          </p>
          <p data-id="element-15">
            <a href="https://trackrq.dailyhomewellness.com/click" className="font-bold text-[#2b6dff] hover:underline" data-id="element-16">
              &gt;&gt;&gt; Is your vision in danger? Click here to take the
              20-seconds eye-discharge test.
            </a>
          </p>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-17">
          <a href="https://trackrq.dailyhomewellness.com/click" className="inline-block rounded-md bg-[#2b6dff] px-8 py-3.5 text-[19px] font-semibold text-white transition-colors hover:bg-[#1d5be0] focus:outline-none focus:ring-2 focus:ring-[#2b6dff] focus:ring-offset-2" data-id="element-18">
            Watch Now &gt;&gt;
          </a>
        </div>
      </main>

      {/* BLUE footer / disclaimer band */}
      <footer className="mt-16 w-full bg-[#c2d6e4] px-6 py-8 text-center text-[#5a6b78]" data-id="element-19">
        <div className="mx-auto max-w-[1150px] space-y-3 leading-relaxed" data-id="element-20">
          <p className="text-[13px]" data-id="element-21">
            THIS IS AN ADVERTORIAL AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
            CONSUMER PROTECTION UPDATE.
          </p>
          <p className="text-[13px] font-medium tracking-wide" data-id="element-22">DISCLAIMER</p>
          <p className="text-[13px]" data-id="element-23">
            This website is not intended to provide medical advice or to take
            the place of medical advice and treatment from your personal
            physician. Visitors are advised to consult their own doctors or
            other qualified health professional regarding the treatment of
            medical conditions. The author shall not be held liable or
            responsible for any misunderstanding or misuse of the information
            contained on this site or for any loss, damage, or injury caused, or
            alleged to be caused, directly or indirectly by any treatment,
            action, or application of any food or food source discussed in this
            website. The U.S. Food and Drug Administration have not evaluated
            the statements on this website. The information is not intended to
            diagnose, treat, cure, or prevent any disease.
          </p>
          <p className="text-[13px]" data-id="element-24">
            Trademarks utilized on our website belong to their respective owners
            and no implied or expressed endorsement of our website or services
            is intended. Through in-depth research and experienced editors we
            provide feedback about products and services. We are independently
            owned, and opinions expressed here are our own. This website is an
            independent professional comparison and review site supported by
            referral fees from the sites and products featured.
          </p>
          <p className="pt-2 text-[13px]" data-id="element-25">
            ©2026 Website Name. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>;
}